// extracted by mini-css-extract-plugin
export default {"overlay":"GlobalPDFLoader_overlay__oaJxo","loaderImage":"GlobalPDFLoader_loaderImage__m2ZVc"};